

import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import Select from "react-select"
import { Button, Spinner } from "react-bootstrap"
import Swal from "sweetalert2"
import {
  getPatientGapldAction,
  createPatientGapldAction,
  updatePatientGapldAction,
  deletePatientGapldAction,
} from "../../../../../store/actions/PatientGapldAction"
import { sendGenderFormLinkAction } from "../../../../../store/actions/PatientLinkAction"
import { showErrorAlert } from "../../../../../services/ErrorHandlingService"
import { formatDate } from "../../../../../utils/dateUtils"
const PatientGapld = () => {
  const dispatch = useDispatch()
  const patientGapldEntries = useSelector((state) => state.patientGapld?.patientGapldEntries || [])
  const patientDetails = useSelector((state) => state.patients?.patientDetails)
  // ADDED: Selector for prescriptionPatientDetails
  const prescriptionPatientDetails = useSelector((state) => state.prescriptionState?.patientDetails)
  // FIXED: Properly derive patient_id from either source
  const patient_id = prescriptionPatientDetails?.patient_id || patientDetails?.patient_id
  const [sending, setSending] = useState(false);
  const [show, setShow] = useState(false)
  const [hovered, setHovered] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false)
  const [currentEditId, setCurrentEditId] = useState("")
  const [loading, setLoading] = useState(false); // For modal form submit


  const [formData, setFormData] = useState({
    pregnancy_status: "",
    medication: "",
    marriage_info_id: "1",

    delivery_date: "",
    How_was_the_delivery: "",
    gender: "",
    which_rx_helped: "",

    // 🔽 ADD THESE FOR L D D+
    child_born_alive: "",        // Yes / No
    death_within_28_days: "",    // Yes / No  → D
    death_after_28_days: "",     // Yes / No  → D+
    currently_alive: "",         // Yes / No  → L

    abortion_date: "",
    pregnancy_month: "",
    death_timing: "",
    how_did_miscarriage_happen: "",
    miscarriage_reason: "",
  })

  const MOCK_GAPLD_ENTRIES = [
    // G1 → L
    {
      gapld_id: "1",
      gapld_status: "Active",
      pregnancy_status: "Delivered",
      delivery_date: "2024-02",
      which_rx_helped: "Ayurvedic",
      How_was_the_delivery: "Normal",
      gender: "Female",
      child_born_alive: "Yes",
      currently_alive: "Yes",
      death_within_28_days: "No",
      death_after_28_days: "No",
      marriage_history: "1st",
    },

    // G2 → A ( <5 months )
    {
      gapld_id: "2",
      gapld_status: "Active",
      pregnancy_status: "Abortion",
      abortion_date: "2023-05",
      pregnancy_month: "3",
      which_rx_helped: "Allopathic",
      marriage_history: "1st",
    },

    // G3 → D
    {
      gapld_id: "3",
      gapld_status: "Active",
      pregnancy_status: "Delivered",
      delivery_date: "2022-01",
      which_rx_helped: "Hormonal",
      How_was_the_delivery: "C-Section",
      gender: "Male",
      child_born_alive: "No",
      death_within_28_days: "Yes",
      death_after_28_days: "No",
      currently_alive: "No",
      marriage_history: "2nd",
    },

    // G4 → M (Miscarriage ≥5 months)
    {
      gapld_id: "4",
      gapld_status: "Active",
      pregnancy_status: "Miscarriage",
      abortion_date: "2021-06",
      pregnancy_month: "6",
      which_rx_helped: "None",
      marriage_history: "2nd",
    },

    // G5 → D+
    {
      gapld_id: "5",
      gapld_status: "Active",
      pregnancy_status: "Delivered",
      delivery_date: "2020-03",
      which_rx_helped: "Ayurvedic",
      How_was_the_delivery: "Normal",
      gender: "Female",
      child_born_alive: "Yes",
      death_within_28_days: "No",
      death_after_28_days: "Yes",
      currently_alive: "No",
      marriage_history: "3rd",
    },
  ]



  const yesNoOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ]

  const deathTimingOptions = [
    { value: "Before28", label: "Before 28 days (D)" },
    { value: "After28", label: "After 28 days (D+)" },
  ]

  const pregnancyMonthOptions = [
    { value: "1", label: "1 Month" },
    { value: "2", label: "2 Months" },
    { value: "3", label: "3 Months" },
    { value: "4", label: "4 Months" },
    { value: "5", label: "5 Months" },
    { value: "6", label: "6 Months" },
    { value: "7", label: "7 Months" },
    { value: "8", label: "8 Months" },
    { value: "9", label: "9 Months" },
  ]

  const marriageHistoryOptions = [
    { value: 1, label: "1st" },
    { value: 2, label: "2nd" },
    { value: 3, label: "3rd" },
    { value: 4, label: "4th" },
    { value: 5, label: "5th" },
  ];
  const [marriageInfoId, setMarriageInfoId] = useState(1);

  // MOVE calculateAge function to the top before it's used
  const calculateAge = (dateString) => {
    if (!dateString || dateString === "0000-00-00") return 0
    const birthDate = new Date(dateString)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  useEffect(() => {
    // FIXED: Use the derived patient_id here
    if (patient_id) {
      dispatch(getPatientGapldAction(patient_id))
    }
  }, [dispatch, patient_id]) // FIXED: Depend on patient_id

  // const getActiveEntriesWithSequentialIds = () => {
  //   const activeEntries = patientGapldEntries
  //     .filter((entry) => entry.gapld_status !== "Delete")
  //     .sort((a, b) => Number.parseInt(a.gapld_id) - Number.parseInt(b.gapld_id))
  //   return activeEntries.map((entry, index) => ({
  //     ...entry,
  //     sequentialId: index + 1,
  //     displayId: `g${index + 1}`,
  //   }))
  // }
  const getActiveEntriesWithSequentialIds = () => {
    return MOCK_GAPLD_ENTRIES.map((entry, index) => ({
      ...entry,
      sequentialId: index + 1,
      displayId: `g${index + 1}`,
    }))
  }

  const calculateA = (entries) => {
    let A = 0

    entries.forEach((e) => {
      if (
        (e.pregnancy_status === "Abortion" ||
          e.pregnancy_status === "Miscarriage") &&
        Number(e.pregnancy_month) < 5
      ) {
        A++
      }
    })

    return A
  }
  const calculateM = (entries) => {
    let M = 0
    entries.forEach((e) => {
      if (
        e.pregnancy_status === "Miscarriage" &&
        Number(e.pregnancy_month) >= 5
      ) {
        M++
      }
    })
    return M
  }

  const calculateLDPlus = (entries) => {
    let L = 0
    let D = 0
    let Dplus = 0

    entries.forEach((e) => {
      if (e.pregnancy_status === "Delivered") {
        if (e.death_within_28_days === "Yes") {
          D++
        } else if (e.death_after_28_days === "Yes") {
          Dplus++
        } else if (e.currently_alive === "Yes") {
          L++
        }
      }
    })

    return { L, D, Dplus }
  }


  const activeEntries = getActiveEntriesWithSequentialIds()
  const { L, D, Dplus } = calculateLDPlus(activeEntries)
  const A = calculateA(activeEntries)
  const M = calculateM(activeEntries)
  const P = M + L + D + Dplus
  const G = A + P


  const formatMonthYear = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    return date.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });
  };


  // Transform data for display - organized by gapld_id sequence, not pregnancy status
  const transformDataForDisplay = () => {
    const displayData = {}
    activeEntries.forEach((entry) => {
      const key = entry.displayId // g1, g2, g3...


      // Format dates
      const deliveryDate =
        entry.delivery_date && entry.delivery_date !== "0000-00-00"
          ? formatMonthYear(entry.delivery_date) // with age
          : "";

      const abortionDate =
        entry.abortion_date && entry.abortion_date !== "0000-00-00"
          ? formatMonthYear(entry.abortion_date) // only date
          : "";
      // Create display data array for each gapld_id
      displayData[key] = [
        // Row 0: Abortion Month, Year, Date of Birth - Age
        entry.pregnancy_status === "Abortion" || entry.pregnancy_status === "Miscarriage"
          ? abortionDate || "Not specified"
          : deliveryDate || "Not specified",
        // Row 1: Which RX helped to maintain pregnancy?
        entry.which_rx_helped || "Not specified",
        entry.marriage_history || "",
        // Row 2: How was the delivery?
        entry.How_was_the_delivery || (entry.pregnancy_status === "Abortion" ||
          entry.pregnancy_status === "Miscarriage"
          ? "N/A" : "Not specified"),
        // Row 3: Male/Female
        entry.gender || (entry.pregnancy_status === "Abortion" || entry.pregnancy_status === "Miscarriage"
          ? "N/A" : "Not specified"),
        // Row 4: How did the miscarriage happen?
        entry.pregnancy_status === "Abortion" || entry.pregnancy_status === "Miscarriage"
          ? entry.how_did_miscarriage_happen || "Not specified"
          : "N/A",
        // Row 5: Miscarriage Reason
        entry.pregnancy_status === "Abortion" || entry.pregnancy_status === "Miscarriage"
          ? entry.miscarriage_reason || "Not specified" : "N/A",
        // Row 6: Details summary
        <div key={`${key}-details`} style={{ whiteSpace: "pre-line" }}>
          {entry.pregnancy_status === "Abortion" || entry.pregnancy_status === "Miscarriage"
            ? `${key.toUpperCase()}\n${abortionDate || "Not specified"}\nAbortion\n${entry.which_rx_helped || "Not specified"
            }\nMiscarriage:\n${entry.how_did_miscarriage_happen || "Not specified"}`
            : `${key.toUpperCase()}\n${deliveryDate || "Not specified"}\n${entry.which_rx_helped || "Not specified"
            }\n${entry.How_was_the_delivery || "Not specified"}\n${entry.gender || "Not specified"}`}
        </div>,

      ]
    })
    return displayData
  }
  const data = transformDataForDisplay()
  const attributes = [
    "Abortion Month, Year, Date of Birth - Age",
    "Which RX helped to maintain pregnancy?",
    "How was the delivery?",
    "Male/Female",
    "How did the miscarriage happen?",
    "Miscarriage Reason",
    "",
  ]
  const deliveryOptionList = [
    { value: "Delivered", label: "Delivered" },
    { value: "Abortion", label: "Abortion" },
    { value: "Miscarriage", label: "Miscarriage" },
  ];
  const medicationOptions = [
    { value: "None", label: "None" },
    { value: "Ayurvedic", label: "Ayurvedic" },
    { value: "Allopathic", label: "Allopathic" },
    { value: "Hormonal", label: "Hormonal" },
    { value: "Other", label: "Other" },
  ];

  const handleInChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleSendLink = async () => {
    if (!patient_id) {
      showErrorAlert("Patient ID not found!");
      return;
    }
    try {
      setSending(true); // 🔄 start loading
      await dispatch(sendGenderFormLinkAction(patient_id, "GAPLD"));
      // handleSuccess("Link sent successfully!");
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to send link");
    } finally {
      setSending(false); // ⏹ stop loading
    }
  };
  const handleinSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // 🛑 Prevent double-click

    setLoading(true);
    const payload = {
      ...formData,
      patient_id,
    };

    try {
      if (isEditMode && currentEditId) {
        const entryToUpdate = activeEntries.find(
          (entry) => entry.displayId === currentEditId
        );
        if (entryToUpdate) {
          payload.gapld_id = entryToUpdate.gapld_id;
          await dispatch(updatePatientGapldAction(payload));
        }
      } else {
        await dispatch(createPatientGapldAction(payload));
      }

      // ✅ Refresh latest data from backend
      await dispatch(getPatientGapldAction(patient_id));

      handleCloseModal();
    } catch (err) {
      console.error("GAPLD submit error:", err);
      showErrorAlert("Failed to save GAPLD record");
    }
    finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      pregnancy_status: "",
      marriage_info_id: "",
      delivery_date: "",
      How_was_the_delivery: "",
      gender: "",
      which_rx_helped: "",

      child_born_alive: "",
      death_within_28_days: "",
      death_after_28_days: "",
      currently_alive: "",

      abortion_date: "",
      pregnancy_month: "",
      death_timing: "",
      how_did_miscarriage_happen: "",
      miscarriage_reason: "",
    })
  }

  const handleCloseModal = () => {
    setShow(false)
    setIsEditMode(false)
    setCurrentEditId("")
    resetForm()
  }
  const handleAddClick = () => {
    setIsEditMode(false)
    setCurrentEditId("")
    resetForm()
    setShow(true)
  }
  const handleEditClick = (displayId) => {
    const entry = activeEntries.find((entry) => entry.displayId === displayId)
    if (entry) {
      setIsEditMode(true)
      setCurrentEditId(displayId)
      setFormData({
        pregnancy_status: entry.pregnancy_status || "",
        marriage_info_id: entry.marriage_info_id || "",

        delivery_date: entry.delivery_date !== "0000-00-00" ? entry.delivery_date : "",
        How_was_the_delivery: entry.How_was_the_delivery || "",
        gender: entry.gender || "",
        which_rx_helped: entry.which_rx_helped || "",

        child_born_alive: entry.child_born_alive || "",
        death_within_28_days: entry.death_within_28_days || "",
        death_after_28_days: entry.death_after_28_days || "",
        currently_alive: entry.currently_alive || "",

        abortion_date: entry.abortion_date !== "0000-00-00" ? entry.abortion_date : "",
        pregnancy_month: entry.pregnancy_month || "",

        how_did_miscarriage_happen: entry.how_did_miscarriage_happen || "",
        miscarriage_reason: entry.miscarriage_reason || "",
      })

      setShow(true)
    }
  }

  const handleDeleteClick = (displayId) => {
    const entry = activeEntries.find((entry) => entry.displayId === displayId)

    if (entry) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won’t be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(deletePatientGapldAction(entry))

          Swal.fire({
            title: "Deleted!",
            text: "The entry has been deleted.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          })
        }
      })
    }
  }

  // Debug logs
  console.log("patientGapldEntries:", patientGapldEntries)
  console.log("activeEntries:", activeEntries)
  console.log("data:", data)
  console.log("show modal:", show)
  console.log("patientDetails marriageInfo:", patientDetails?.marriageInfo)
  const getMarriageHistoryOptions = () => {
    // Fixed: Return empty array if no marriage info available or if it's empty
    if (!patientDetails?.marriageInfo || patientDetails.marriageInfo.length === 0) {
      return []
    }
    return patientDetails.marriageInfo.map((marriage) => ({
      value: marriage.marriage_info_id,
      label: marriage.marriage_history,
    }))
  }
  // Helper function to get marriage history text by ID
  const getMarriageHistoryText = (marriageInfoId) => {
    console.log("Looking for marriage_info_id:", marriageInfoId, typeof marriageInfoId)
    console.log("Available marriage info:", patientDetails?.marriageInfo)
    if (!patientDetails?.marriageInfo || !marriageInfoId) return "Not specified"
    // Use loose equality (==) instead of strict equality (===) to handle type differences
    const marriageInfo = patientDetails.marriageInfo.find((marriage) => marriage.marriage_info_id == marriageInfoId) // Note: using == instead of ===
    console.log("Found marriage info:", marriageInfo)
    return marriageInfo?.marriage_history || "Not specified"
  }
  // Show message if no data available

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: "0px",
      fontSize: "14px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "14px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "14px",
    }),
  };

  const getStatusLabel = (e) => {
    if (e.pregnancy_status === "Delivered") {
      if (e.death_within_28_days === "Yes") return "D"
      if (e.death_after_28_days === "Yes") return "D+"
      if (e.currently_alive === "Yes") return "L"
    }

    if (e.pregnancy_status === "Miscarriage") return "M"
    if (e.pregnancy_status === "Abortion") return "A"

    return ""
  }


  if (activeEntries.length === 0) {
    return (
      <div className="row">
        <div className="col-xl-12">
          <div className="card shadow-none">
            <div className="card-body">
              <div className="text-end mb-3 d-flex gap-2 justify-content-end align-items-center">

                {/* <button className="btn btn-primary" onClick={handleAddClick}>
                  Add
                </button>
                <button
                  className="btn btn-primary"
                  disabled={sending} // ✅ disable while loading
                  onClick={handleSendLink}
                >
                  {sending ? "Sending..." : "Send Link"}
                </button> */}
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={handleAddClick}
                >
                  Add
                </Button>

                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={sending}   // disable while loading
                  onClick={handleSendLink}
                >
                  {sending ? "Sending..." : "Send Link"}
                </Button>
                <Button
                  size="sm"
                  variant="outline-success"
                  onClick={() => window.open("/public/gapld-form", "_blank")}
                >
                  Open Public GAPLD
                </Button>
                <Button
                  size="sm"
                  variant="outline-success"
                  onClick={() => window.open("/public/gplda-form", "_blank")}
                >
                  Open New GPLDA
                </Button>
              </div>
              <div className="text-center py-5">
                <h5 className="text-muted">No GAPLD records found</h5>
                <p className="text-muted">Click "Add" to create a new record</p>
              </div>
            </div>
          </div>
        </div>
        {/* Modal for Add - Always render */}
        {show && (
          <div
            className="modal"
            style={{
              display: "block",
              position: "fixed",
              zIndex: 1050,
              left: 0,
              top: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                handleCloseModal()
              }
            }}
          >
            <div className="modal-dialog modal-lg" style={{ margin: "1.75rem auto" }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                    style={{ background: "none", border: "none", fontSize: "1.5rem" }}
                  >
                    ×
                  </button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleinSubmit}>
                    <div className="mb-3">
                      <label htmlFor="pregnancy_status" style={{ marginBottom: "0.5rem" }}>
                        Pregnancy Status<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        name="pregnancy_status"
                        options={deliveryOptionList}
                        value={
                          formData.pregnancy_status
                            ? deliveryOptionList.find((opt) => opt.value === formData.pregnancy_status)
                            : null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            pregnancy_status: selectedOption?.value || "",
                          }))
                        }
                        placeholder="Select Pregnancy Status"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Which Medication<span style={{ color: "red" }}>*</span>
                      </label>

                      <Select
                        name="medication"
                        options={medicationOptions}
                        value={
                          formData.medication
                            ? medicationOptions.find((opt) => opt.value === formData.medication)
                            : null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            medication: selectedOption?.value || "",
                          }))
                        }
                        placeholder="Select Medication"
                        styles={customStyles}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Marriage History<span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <select
                        className="form-select"
                        name="marriage_info_id"
                        value={formData.marriage_info_id}
                        onChange={handleInChange}
                        style={{ height: "50px" }}
                        required
                      >
                        <option value="">Select Marriage History</option>
                        {getMarriageHistoryOptions().map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))} */}
                      <Select
                        options={marriageHistoryOptions}
                        value={marriageHistoryOptions.find((opt) => opt.value === marriageInfoId) || null}
                        onChange={(selected) => setMarriageInfoId(selected?.value || 1)}
                        placeholder="Select Marriage History"
                        isClearable
                        styles={customStyles}
                      />
                    </div>
                    {formData.pregnancy_status === "Abortion" && (
                      <div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="abortion_date">
                              Abortion Date <span style={{ color: "red" }}>*</span>
                            </label>

                            <input
                              id="abortion_date"
                              type="month"
                              className="form-control"
                              name="abortion_date"
                              value={formData.abortion_date}
                              onChange={handleInChange}
                              max={new Date().toISOString().slice(0, 7)} // YYYY-MM
                              required
                            />
                          </div>

                          <div className="col-xl-6 mb-3">
                            <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                            <input
                              id="which_rx_helped"
                              type="text"
                              className="form-control"
                              name="which_rx_helped"
                              value={formData.which_rx_helped}
                              onChange={handleInChange}
                              placeholder="Enter RX"
                            />
                          </div>
                        </div>
                        <div className="row">
                          {/* <div className="col-xl-6 mb-3">
                            <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                            <input
                              id="how_did_miscarriage_happen"
                              type="text"
                              className="form-control"
                              name="how_did_miscarriage_happen"
                              value={formData.how_did_miscarriage_happen}
                              onChange={handleInChange}
                              placeholder="Enter details"
                            />
                          </div> */}
                          {/* <div className="col-xl-6 mb-3">
                            <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                            <input
                              id="miscarriage_reason"
                              type="text"
                              className="form-control"
                              name="miscarriage_reason"
                              value={formData.miscarriage_reason}
                              onChange={handleInChange}
                              placeholder="Enter reason"
                            />
                          </div> */}
                        </div>
                      </div>
                    )}
                    {formData.pregnancy_status === "Miscarriage" && (
                      <div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="abortion_date">
                              Miscarriage Date <span style={{ color: "red" }}>*</span>
                            </label>

                            <input
                              id="abortion_date"
                              type="month"
                              className="form-control"
                              name="abortion_date"
                              value={formData.abortion_date}
                              onChange={handleInChange}
                              max={new Date().toISOString().slice(0, 7)} // YYYY-MM
                              required
                            />
                          </div>

                          <div className="col-xl-6 mb-3">
                            <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                            <input
                              id="which_rx_helped"
                              type="text"
                              className="form-control"
                              name="which_rx_helped"
                              value={formData.which_rx_helped}
                              onChange={handleInChange}
                              placeholder="Enter RX"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                            <input
                              id="how_did_miscarriage_happen"
                              type="text"
                              className="form-control"
                              name="how_did_miscarriage_happen"
                              value={formData.how_did_miscarriage_happen}
                              onChange={handleInChange}
                              placeholder="Enter details"
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                            <input
                              id="miscarriage_reason"
                              type="text"
                              className="form-control"
                              name="miscarriage_reason"
                              value={formData.miscarriage_reason}
                              onChange={handleInChange}
                              placeholder="Enter reason"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {formData.pregnancy_status === "Delivered" && (
                      <div>
                        <div className="row">
                          <div className="col-6 mb-3">
                            <label htmlFor="delivery_date">Delivery Date<span style={{ color: "red" }}>*</span></label>
                            <input
                              id="delivery_date"
                              type="month"
                              className="form-control"
                              name="delivery_date"
                              value={formData.delivery_date}
                              onChange={handleInChange}
                              max={new Date().toISOString().slice(0, 7)}
                              required
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                            <input
                              id="which_rx_helped"
                              type="text"
                              className="form-control"
                              name="which_rx_helped"
                              value={formData.which_rx_helped}
                              onChange={handleInChange}
                              placeholder="Enter RX"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="How_was_the_delivery">How was the delivery?</label>
                            <input
                              id="How_was_the_delivery"
                              type="text"
                              className="form-control"
                              name="How_was_the_delivery"
                              value={formData.How_was_the_delivery}
                              onChange={handleInChange}
                              placeholder="Enter delivery details"
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="gender">Male/Female/Transgender</label>
                            <select
                              id="gender"
                              className="form-control"
                              name="gender"
                              value={formData.gender}
                              onChange={handleInChange}
                            >
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Transgender">Transgender</option>
                            </select>
                          </div>
                        </div>


                      </div>
                    )}
                    <button type="submit" className="btn btn-primary mt-3">
                      Save Changes
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div >
        )}
      </div >
    )
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card shadow-none">
          <div className="card-body">
            <div className="text-end mb-3">
              <div className="d-flex justify-content-end">
                <button className="btn btn-outline-primary btn-sm me-2" onClick={handleAddClick}>
                  Add
                </button>

                <button
                  className="btn btn-outline-primary btn-sm me-2"
                  disabled={sending}
                  onClick={handleSendLink}
                >
                  {sending ? "Sending..." : "Send Link"}
                </button>
                <Button
                  size="sm"
                  variant="outline-success"
                  onClick={() => window.open("/public/gplda-form", "_blank")}
                >
                  Open New GPLDA
                </Button>
                <Button
                  size="sm"
                  variant="outline-success"
                  onClick={() => window.open("/public/gapld-form", "_blank")}
                >
                  Open Public GAPLD
                </Button>
              </div>

            </div>
            <div className="table-responsive">
              <div id="patient" className="dataTables_wrapper no-footer">
                <table
                  className="table header-border"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "2px solid #ddd",
                    margin: "0 auto",
                  }}
                >
                  <thead style={{ color: "black", fontWeight: "bold" }}>
                    <tr className="table-info">
                      <th scope="col"></th>
                      {activeEntries.map((entry) => (
                        // <th
                        //   key={entry.displayId}
                        //   scope="col"
                        //   style={{
                        //     color: "black",
                        //     fontWeight: "bold",
                        //     padding: "10px",
                        //     backgroundColor: entry.sequentialId <= 2 ? "yellow" : "lightgreen",
                        //     textAlign: "center",
                        //     position: "relative",
                        //   }}
                        //   onMouseEnter={() => setHovered(entry.displayId)}
                        //   onMouseLeave={() => setHovered(null)}
                        // >
                        //   <div style={{ whiteSpace: "pre-line" }}>
                        //     {`${entry.displayId.toUpperCase()} (${getStatusLabel(entry) || "N/A"})\n${formatMonthYear(
                        //       entry.pregnancy_status === "Abortion" || entry.pregnancy_status === "Miscarriage"
                        //         ? entry.abortion_date
                        //         : entry.delivery_date
                        //     )}`}
                        //   </div>


                        //   <div
                        //     className="tooltip"
                        //     style={{
                        //       position: "absolute",
                        //       backgroundColor: "black",
                        //       color: "white",
                        //       padding: "5px",
                        //       borderRadius: "4px",
                        //       visibility: hovered === entry.displayId ? "visible" : "hidden",
                        //       opacity: hovered === entry.displayId ? 1 : 0,
                        //       transition: "opacity 0.3s",
                        //       zIndex: 10,
                        //       top: "50px",
                        //       left: "50%",
                        //       transform: "translateX(-50%)",
                        //     }}
                        //   >
                        //     {entry.marriage_history
                        //       ? `${entry.marriage_history} Marriage`
                        //       : "Not specified"}
                        //   </div>
                        // </th>
                        <th
                          key={`${entry.displayId}-top`}
                          style={{
                            textAlign: "center",
                            padding: "10px",
                          }}
                        >
                          {entry.displayId.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                    <tr className="table-warning">
                      {/* <tr className="table-warning"> */}
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          padding: "10px",
                          textAlign: "center",
                        }}
                      >
                        {`G (${G}) = A (${A}) + P (${P})`}
                      </th>
                      {activeEntries.map((entry) => (
                        <th
                          key={entry.displayId}
                          scope="col"
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            padding: "10px",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {getStatusLabel(entry) || "N/A"}
                          <div className="mt-2 d-flex justify-content-center gap-3">
                            <i
                              className="fa fa-pencil-alt text-success"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEditClick(entry.displayId)}
                              title="Edit"
                            />
                            <i
                              className="fa fa-trash text-danger"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteClick(entry.displayId)}
                              title="Delete"
                            />
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ backgroundColor: "white" }}>
                    {attributes.map((attribute, index) => (
                      <tr key={index}>
                        <th
                          scope="row"
                          style={{
                            color: "black",
                            fontWeight: "normal",
                            padding: "10px",
                          }}
                        >
                          {attribute}
                        </th>
                        {activeEntries.map((entry) => {
                          // Adjust index to match the original displayData structure
                          // The original attributes array has 7 elements (0-6)
                          // The original displayData has 8 elements (0-7)
                          // The marriage_history was at index 2 in displayData but not explicitly in attributes
                          // The last element of displayData (details summary) was at index 7, corresponding to attributes[6] (empty string)
                          let cellValue
                          if (index === 2) {
                            // This is where "How was the delivery?" is in attributes
                            // In the original code, displayData[2] was marriage_history, displayData[3] was How_was_the_delivery
                            // So, if attribute is "How was the delivery?", we need displayData[3]
                            cellValue = data[entry.displayId]?.[index + 1] || "N/A"
                          } else if (index > 2) {
                            // For attributes after "How was the delivery?"
                            cellValue = data[entry.displayId]?.[index + 1] || "N/A"
                          } else {
                            // For attributes before "How was the delivery?"
                            cellValue = data[entry.displayId]?.[index] || "N/A"
                          }

                          // Special handling for the last attribute (empty string) to show the details summary
                          if (index === attributes.length - 1) {
                            cellValue = data[entry.displayId]?.[7] || "N/A"
                          }

                          return (
                            <td
                              key={entry.displayId}
                              style={{
                                padding: "10px",
                                backgroundColor: "white",
                                textAlign: "left",
                              }}
                            >
                              {cellValue}
                            </td>
                          )
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Modal - Fixed Implementation */}
            {show && (
              <div
                className="modal"
                style={{
                  display: "block",
                  position: "fixed",
                  zIndex: 1050,
                  left: 0,
                  top: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    handleCloseModal()
                  }
                }}
              >
                <div className="modal-dialog modal-lg" style={{ margin: "1.75rem auto" }}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {isEditMode ? `Edit Details (${currentEditId.toUpperCase()})` : "Add Details"}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleCloseModal}
                        style={{ background: "none", border: "none", fontSize: "1.5rem" }}
                      >
                        ×
                      </button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleinSubmit}>
                        <div className="mb-3">
                          <label className="form-label fw-bold" htmlFor="pregnancy_status" style={{ marginBottom: "0.5rem" }}>
                            Pregnancy Status<span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            name="pregnancy_status"
                            options={deliveryOptionList}
                            value={
                              formData.pregnancy_status
                                ? deliveryOptionList.find((opt) => opt.value === formData.pregnancy_status)
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                pregnancy_status: selectedOption?.value || "",
                              }))
                            }
                            placeholder="Select Pregnancy Status"
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Which Medication<span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            name="medication"
                            options={medicationOptions}
                            value={
                              formData.medication
                                ? medicationOptions.find((opt) => opt.value === formData.medication)
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                medication: selectedOption?.value || "",
                              }))
                            }
                            placeholder="Select Medication"
                            styles={customStyles}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Marriage History<span style={{ color: "red" }}>*</span>
                          </label>
                          {/* <select
                          className="form-select"
                          name="marriage_info_id"
                          value={formData.marriage_info_id}
                          onChange={handleInChange}
                          style={{ height: "50px" }}
                          required
                        >
                          <option value="">Select Marriage History</option>
                          {getMarriageHistoryOptions().map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select> */}
                          <Select
                            options={marriageHistoryOptions}
                            value={marriageHistoryOptions.find((opt) => opt.value === marriageInfoId) || null}
                            onChange={(selected) => setMarriageInfoId(selected?.value || 1)}
                            placeholder="Select Marriage History"
                            isClearable
                            styles={customStyles}
                          />

                        </div>
                        {formData.pregnancy_status === "Abortion" && (
                          <div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="abortion_date">Abortion Date</label>
                                <input
                                  id="abortion_date"
                                  type="month"
                                  className="form-control"
                                  name="abortion_date"
                                  value={formData.abortion_date}
                                  onChange={handleInChange}
                                  max={new Date().toISOString().slice(0, 7)}
                                  required
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="pregnancy_month">
                                  Pregnancy Month <span style={{ color: "red" }}>*</span>
                                </label>

                                <Select
                                  name="pregnancy_month"
                                  options={pregnancyMonthOptions}
                                  value={
                                    formData.pregnancy_month
                                      ? pregnancyMonthOptions.find(
                                        (opt) => opt.value === formData.pregnancy_month
                                      )
                                      : null
                                  }
                                  onChange={(selected) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      pregnancy_month: selected?.value || "",
                                    }))
                                  }
                                  placeholder="Select Month"
                                  isClearable
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: "50px",     // ⬅ increase height
                                      height: "48px",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      height: "48px",
                                      padding: "0 10px",
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      margin: "0px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                      ...base,
                                      height: "48px",
                                    }),
                                  }}
                                />
                              </div>

                              <div className="col-xl-6 mb-3">
                                <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                                <input
                                  id="which_rx_helped"
                                  type="text"
                                  className="form-control"
                                  name="which_rx_helped"
                                  value={formData.which_rx_helped}
                                  onChange={handleInChange}
                                  placeholder="Enter RX"
                                />
                              </div>
                            </div>
                            <div className="row">
                              {/* <div className="col-xl-6 mb-3">
                                <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                                <input
                                  id="how_did_miscarriage_happen"
                                  type="text"
                                  className="form-control"
                                  name="how_did_miscarriage_happen"
                                  value={formData.how_did_miscarriage_happen}
                                  onChange={handleInChange}
                                  placeholder="Enter details"
                                />
                              </div> */}
                              {/* <div className="col-xl-6 mb-3">
                                <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                                <input
                                  id="miscarriage_reason"
                                  type="text"
                                  className="form-control"
                                  name="miscarriage_reason"
                                  value={formData.miscarriage_reason}
                                  onChange={handleInChange}
                                  placeholder="Enter reason"
                                />
                              </div> */}
                            </div>
                          </div>
                        )}
                        {formData.pregnancy_status === "Miscarriage" && (
                          <div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="abortion_date">Miscarriage Date</label>
                                <input
                                  id="abortion_date"
                                  type="month"
                                  className="form-control"
                                  name="abortion_date"
                                  value={formData.abortion_date}
                                  onChange={handleInChange}
                                  max={new Date().toISOString().slice(0, 7)}
                                  required
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="pregnancy_month">
                                  Pregnancy Month <span style={{ color: "red" }}>*</span>
                                </label>

                                <Select
                                  name="pregnancy_month"
                                  options={pregnancyMonthOptions}
                                  value={
                                    formData.pregnancy_month
                                      ? pregnancyMonthOptions.find(
                                        (opt) => opt.value === formData.pregnancy_month
                                      )
                                      : null
                                  }
                                  onChange={(selected) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      pregnancy_month: selected?.value || "",
                                    }))
                                  }
                                  placeholder="Select Month"
                                  isClearable
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: "50px",     // ⬅ increase height
                                      height: "48px",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      height: "48px",
                                      padding: "0 10px",
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      margin: "0px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                      ...base,
                                      height: "48px",
                                    }),
                                  }}
                                />
                              </div>

                              <div className="col-xl-6 mb-3">
                                <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                                <input
                                  id="which_rx_helped"
                                  type="text"
                                  className="form-control"
                                  name="which_rx_helped"
                                  value={formData.which_rx_helped}
                                  onChange={handleInChange}
                                  placeholder="Enter RX"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                                <input
                                  id="how_did_miscarriage_happen"
                                  type="text"
                                  className="form-control"
                                  name="how_did_miscarriage_happen"
                                  value={formData.how_did_miscarriage_happen}
                                  onChange={handleInChange}
                                  placeholder="Enter details"
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                                <input
                                  id="miscarriage_reason"
                                  type="text"
                                  className="form-control"
                                  name="miscarriage_reason"
                                  value={formData.miscarriage_reason}
                                  onChange={handleInChange}
                                  placeholder="Enter reason"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {formData.pregnancy_status === "Delivered" && (
                          <div>
                            <div className="row">
                              <div className="col-6 mb-3">
                                <label htmlFor="delivery_date">Delivery Date</label>
                                <input
                                  id="delivery_date"
                                  type="month"
                                  className="form-control"
                                  name="delivery_date"
                                  value={formData.delivery_date}
                                  onChange={handleInChange}
                                  max={new Date().toISOString().slice(0, 7)}
                                  required
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                                <input
                                  id="which_rx_helped"
                                  type="text"
                                  className="form-control"
                                  name="which_rx_helped"
                                  value={formData.which_rx_helped}
                                  onChange={handleInChange}
                                  placeholder="Enter RX"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="How_was_the_delivery">How was the delivery?</label>
                                <input
                                  id="How_was_the_delivery"
                                  type="text"
                                  className="form-control"
                                  name="How_was_the_delivery"
                                  value={formData.How_was_the_delivery}
                                  onChange={handleInChange}
                                  placeholder="Enter delivery details"
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="gender">Gender</label>
                                <select
                                  id="gender"
                                  className="form-control"
                                  name="gender"
                                  value={formData.gender}
                                  onChange={handleInChange}
                                >
                                  <option value="">Select Gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Transgender">Transgender</option>
                                </select>
                              </div>
                            </div>
                            {/* Delivery Outcome – L, D, D+ */}
                            {/* Delivery Outcome – L, D, D+ */}
                            <div className="row">
                              {/* Child born alive */}
                              <div className="col-xl-6 mb-3">
                                <label>Was the child born alive?</label>
                                <Select
                                  options={yesNoOptions}
                                  value={
                                    formData.child_born_alive
                                      ? yesNoOptions.find((o) => o.value === formData.child_born_alive)
                                      : null
                                  }
                                  onChange={(selected) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      child_born_alive: selected?.value || "",
                                      // reset dependent fields
                                      death_timing: "",
                                      death_within_28_days: "",
                                      death_after_28_days: "",
                                      currently_alive: "",
                                    }))
                                  }
                                  placeholder="Select"
                                  styles={customStyles}
                                />
                              </div>

                              {/* Death timing when child NOT born alive */}
                              {formData.child_born_alive === "No" && (
                                <div className="col-xl-6 mb-3">
                                  <label>When did the child die?</label>
                                  <Select
                                    options={deathTimingOptions}
                                    value={
                                      formData.death_timing
                                        ? deathTimingOptions.find(
                                          (o) => o.value === formData.death_timing
                                        )
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const value = selected?.value || ""
                                      setFormData((prev) => ({
                                        ...prev,
                                        death_timing: value,
                                        death_within_28_days: value === "Before28" ? "Yes" : "No",
                                        death_after_28_days: value === "After28" ? "Yes" : "No",
                                        currently_alive: "No",
                                      }))
                                    }}
                                    placeholder="Select"
                                    styles={customStyles}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {/* <button type="submit" className="btn btn-primary mt-3">
                          {isEditMode ? "Update" : "Save Changes"}
                        </button> */}
                        <button
                          type="submit"
                          className="btn btn-primary mt-3"
                          disabled={loading}
                          style={{ minWidth: "130px" }}
                        >
                          {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {isEditMode ? "Updating..." : "Saving..."}
                            </>
                          ) : (
                            isEditMode ? "Update" : "Save Changes"
                          )}
                        </button>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PatientGapld;
